import React from 'react';
import './CustomSelect.css';

class CustomSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      searchTerm: '',
    };
    this.wrapperRef = React.createRef();
    this.handleToggle = this.handleToggle.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ isOpen: false, searchTerm: '' });
    }
  }

  handleToggle() {
    if (!this.props.disabled) {
      this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    }
  }

  handleOptionClick(optionValue) {
    if (!this.props.disabled) {
      const event = {
        target: {
          name: this.props.name,
          value: optionValue,
        },
      };
      this.props.onChange(event);
      this.setState({ isOpen: false, searchTerm: '' });
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.setState({ isOpen: false, searchTerm: '' });
    }
  }

  handleSearchChange(event) {
    this.setState({ searchTerm: event.target.value });
  }

  render() {
    const { 
      options = [], 
      value, 
      placeholder, 
      disabled, 
      className = '', 
      showEmptyOption = true,
      emptyOptionText,
      searchable = false,
    } = this.props;
    const { isOpen, searchTerm } = this.state;

    const selectedOption = options.find(opt => {
      const optValue = opt.value ?? opt.label ?? opt;
      return optValue === value;
    });

    const selectedLabel = selectedOption 
      ? (selectedOption.label ?? selectedOption)
      : (placeholder || 'Select an option');

    const filteredOptions = searchable && searchTerm
      ? options.filter(opt => {
          const label = opt.label ?? opt;
          const description = opt.description ?? '';
          const searchLower = searchTerm.toLowerCase();
          return label.toLowerCase().includes(searchLower) || 
                 description.toLowerCase().includes(searchLower);
        })
      : options;

    return (
      <div
        ref={this.wrapperRef}
        className={`custom-select ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''} ${className}`}
        onKeyDown={this.handleKeyDown}
      >
        <div
          data-th-typography="form-control"
          className={`custom-select-trigger ${!selectedOption ? 'placeholder' : ''}`}
          onClick={this.handleToggle}
          tabIndex={disabled ? -1 : 0}
        >
          <span data-th-typography="form-control" className="custom-select-value">{selectedLabel}</span>
          <span className="custom-select-arrow">
            <i className={`bx ${isOpen ? 'bx-chevron-up' : 'bx-chevron-down'}`}></i>
          </span>
        </div>

        {isOpen && (
          <div data-th-typography="form-control" className="custom-select-dropdown">
            {searchable && (
              <div className="custom-select-search">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={this.handleSearchChange}
                  onClick={(e) => e.stopPropagation()}
                  autoFocus
                />
              </div>
            )}
            <div className="custom-select-options">
              {showEmptyOption && (
                <div
                  className={`custom-select-option ${!value ? 'selected' : ''}`}
                  onClick={() => this.handleOptionClick('')}
                >
                  <div data-th-typography="form-option-title" className="option-label">
                    {emptyOptionText || placeholder || 'Select an option'}
                  </div>
                </div>
              )}
              {filteredOptions.length === 0 && searchTerm && (
                <div className="custom-select-option disabled">
                  <div data-th-typography="form-option-title" className="option-label">No results found</div>
                </div>
              )}
              {filteredOptions.map((option, index) => {
                const optValue = option.value ?? option.label ?? option;
                const optLabel = option.label ?? option;
                const optDescription = option.description;
                const isSelected = optValue === value;

                return (
                  <div
                    key={index}
                    className={`custom-select-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => this.handleOptionClick(optValue)}
                  >
                    <div className="option-content">
                      <div data-th-typography="form-option-title" className="option-label">{optLabel}</div>
                      {optDescription && (
                        <div data-th-typography="form-option-description" className="option-description">{optDescription}</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CustomSelect;
